module.exports = __webpack_public_path__ + "static/media/mtg-questions.a59e3708.csv";